import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"

import {
  CustomerPotentialModel,
  CustomerPotentialUpdateModel,
} from "@models/customer/customerPotentialModel"

const getCustomerPotentialAuditFieldLabels = (): Record<string, string> => ({
  FullName:              L("CUSTOMER_POTENTIAL_FULL_NAME"),
  IdentifierCardNumber:  L("CUSTOMER_DETAIL_INDENTIFIER_CARD_NUMBER"),
  IdIssuedDate:          L("CUSTOMER_DETAIL_ID_ISSUED_DATE"),
  IdIssuedPlace:         L("CUSTOMER_DETAIL_ID_ISSUED_PLACE"),
  NationalityId:         L("CUSTOMER_DETAIL_COUNTRY"),
  Position:              L("CUSTOMER_DETAIL_POSITION"),
  NecessaryLevel:        L("CUSTOMER_POTENTIAL_NEED_LEVEL"),
  CustomerType:          L("CUSTOMER_POTENTIAL_CUSTOMER_TYPE"),
  Gender:                L("CUSTOMER_DETAIL_GENDER"),
  BirthDate:             L("CUSTOMER_POTENTIAL_BIRTH_DATE"),
  ConsultantId:          L("CUSTOMER_POTENTIAL_AGENT"),
  AgencyMasterId:        L("CONTRACT_BOOKING_DETAIL_AGENCY_MASTER"),
  Tags:                  L("CUSTOMER_POTENTIAL_TAGS"),
  BankAddress:           L("CUSTOMER_DETAIL_ADDRESS"),
  BankBranch:            L("CUSTOMER_DETAIL_BANK_BRANCH"),
  BankSwiftCode:         L("CUSTOMER_DETAIL_COMMONLY_USED_BANK"),
  BankName:              L("CUSTOMER_DETAIL_COMMONLY_USED_BANK"),
  BankNumber:            L("BOOKING_DETAIL_BANK_NUMBER"),
  Beneficiary:           L("CUSTOMER_DETAIL_BENEFICIARY"),
})

class CustomerPotentialService {
  public async create(body: any) {
    const newBody = CustomerPotentialUpdateModel.assign(body)

    const res = await http.post("api/services/app/Customers/Create", newBody)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async update(body: any) {
    const newBody = CustomerPotentialUpdateModel.assign(body)

    const res = await http.put("api/services/app/Customers/Update", newBody)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async activateOrDeactivate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/Customers/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkActive(id: number[]) {
    const res = await http.post("api/services/app/Customers/BulkActive", id)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Customers/GetAll", { params })
    return res.data.result
  }

  public async getECI(params: any): Promise<any> {
    const res = await http.get("api/services/app/Customers/GetECI", { params })
    return res.data.result
  }

  public async get(id: number, isViewFull: boolean = false): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Customers/GetById", {
      params: { id, isViewFull },
    })
    const { result } = res.data
    return CustomerPotentialModel.assign(result)
  }
  public async getAutoComplete(params): Promise<any> {
    const res = await http.post(
      "api/services/app/Customers/AutoComplete",
      {},
      { params }
    )

    const { result } = res.data
    return CustomerPotentialModel.assigns(result)
  }
  public async checkExist(params): Promise<any> {
    //?identifierCardNumber=2&agencyMasterId=2
    const res = await http.post(
      "api/services/app/Customers/CheckExist",
      {},
      { params }
    )

    const { result } = res.data
    return result
  }

  public async updateSpecialCare(body: any) {
    const res = await http.put(
      "api/services/app/Customers/UpdateSpecialCare",
      body
    )

    return res.data.result
  }

  public async updateStatus(body: any) {
    const res = await http.put("api/services/app/Customers/UpdateStatus", body)

    return res.data.result
  }
  public async getAuditLog(id: any) {
    const res = await http.get("api/services/app/Customers/GetAuditLogs", {
      params: { id },
    })
    const labels = getCustomerPotentialAuditFieldLabels()
    return (res.data.result || []).map((row: any) => {
      ;(row.items || []).forEach((item: any) => {
        item.propertyName = labels[item.propertyName] ?? item.propertyName
      })
      return row
    })
  }
}

export default new CustomerPotentialService()
